import TagSelection from './TagSelection';
import _ExpandableTagSelection from './ExpandableTagSelection';

export const ExpandableTagSelection = _ExpandableTagSelection
export default TagSelection